import {palette} from './styleVariables';

// Converts short (3 chars) and regular hex color codes to rgba format using the provided alpha value.
//   Supported hex formats: #000, 000, 000000, #000000
export const convertHexToRGBA = (hex: string, alpha: number, type: 'rgb' | 'rgba' = 'rgba') => {
  const hexValue = hex.replace('#', '');
  const r = parseInt(hexValue.length === 3 ? hexValue.slice(0, 1).repeat(2) : hexValue.slice(0, 2), 16);
  const g = parseInt(hexValue.length === 3 ? hexValue.slice(1, 2).repeat(2) : hexValue.slice(2, 4), 16);
  const b = parseInt(hexValue.length === 3 ? hexValue.slice(2, 3).repeat(2) : hexValue.slice(4, 6), 16);

  if (type === 'rgb')
    return `rgb(${r},${g},${b})`;


  return `rgba(${r},${g},${b},${alpha})`;
};

export function getTextColorByBackground(hex: string) {
  const hexValue = hex.replace('#', '');
  const r = parseInt(hexValue.length === 3 ? hexValue.slice(0, 1).repeat(2) : hexValue.slice(0, 2), 16);
  const g = parseInt(hexValue.length === 3 ? hexValue.slice(1, 2).repeat(2) : hexValue.slice(2, 4), 16);
  const b = parseInt(hexValue.length === 3 ? hexValue.slice(2, 3).repeat(2) : hexValue.slice(4, 6), 16);
  const val = r * 0.299 + g * 0.587 + b * 0.114;

  if (val > 186)
    return palette.black.base;

  return palette.white.highlight;
}
